module.exports = __webpack_public_path__ + "img/lifeBlock_2_en.8d59aec9.png";